import React from "react";

export default function RecurringScheduleCard({

    enabled,

    schedule,

    setSchedule

}) {

    if (!enabled) {

        return null;

    }
    const isExecuted =     !!schedule.last_run_date;

    function handleChange(
        field,
        value
    ) {

        setSchedule((prev) => ({

            ...prev,

            [field]: value

        }));

    }

    return (

        <div className="card mt-3">

            <div className="card-header">

                <strong>

                    Recurring Schedule

                </strong>

            </div>

            <div className="card-body">
                {
                    isExecuted && (

                        <div className="alert alert-info mb-3">

                            <strong>Note:</strong>

                            This recurring schedule has already generated work.
                            Frequency, Start Date and Template Items cannot
                            be modified after the first execution.

                        </div>

                    )
                }

                <div className="row">

                    {/* Schedule Name */}

                    <div className="col-md-6 mb-3">

                        <label>

                            Schedule Name *

                        </label>

                        <input
                            className="form-control"
                            value={schedule.schedule_name}
                            onChange={(e) =>
                                handleChange(
                                    "schedule_name",
                                    e.target.value
                                )
                            }
                        />

                    </div>

                    {/* Frequency */}

                    <div className="col-md-3 mb-3">

                        <label>

                            Frequency

                        </label>

                        <select
                            className="form-control"
                            value={schedule.frequency}
                            disabled={isExecuted}
                            onChange={(e) =>
                                handleChange(
                                    "frequency",
                                    e.target.value
                                )
                            }
                        >

                            <option value="DAILY">
                                Daily
                            </option>

                            <option value="WEEKLY">
                                Weekly
                            </option>

                            <option value="MONTHLY">
                                Monthly
                            </option>

                            <option value="QUARTERLY">
                                Quarterly
                            </option>

                            <option value="HALF_YEARLY">
                                Half Yearly
                            </option>

                            <option value="YEARLY">
                                Yearly
                            </option>

                        </select>

                    </div>

                    {/* Interval */}

                    <div className="col-md-3 mb-3">

                        <label>

                            Interval

                        </label>

                        <input
                            type="number"
                            min="1"
                            className="form-control"
                            value={schedule.interval_value}
                            readOnly
                            onChange={(e) =>
                                handleChange(
                                    "interval_value",
                                    e.target.value
                                )
                            }
                        />

                    </div>

                    {/* Start Date */}

                    <div className="col-md-4 mb-3">

                        <label>

                            Start Date

                        </label>

                        <input
                            type="date"
                            className="form-control"
                            value={schedule.start_date}
                            disabled={isExecuted}
                            onChange={(e) =>
                                handleChange(
                                    "start_date",
                                    e.target.value
                                )
                            }
                        />

                    </div>

                    {/* End Date */}

                    <div className="col-md-4 mb-3">

                        <label>

                            End Date

                        </label>

                        <input
                            type="date"
                            className="form-control"
                            value={schedule.end_date}
                            onChange={(e) =>
                                handleChange(
                                    "end_date",
                                    e.target.value
                                )
                            }
                        />

                    </div>

                    {/* Execution Time */}

                    <div className="col-md-4 mb-3">

                        <label>

                            Execution Time

                        </label>

                        <input
                            type="time"
                            className="form-control"
                            value={schedule.execution_time}
                            onChange={(e) =>
                                handleChange(
                                    "execution_time",
                                    e.target.value
                                )
                            }
                        />

                    </div>

                    {/* Pending Strategy */}

                    <div className="col-md-6 mb-3">

                        <label>

                            Pending Work Strategy

                        </label>

                        <select
                            className="form-control"
                            value={schedule.pending_work_strategy}
                            onChange={(e) =>
                                handleChange(
                                    "pending_work_strategy",
                                    e.target.value
                                )
                            }
                        >

                            <option value="ALLOW_MULTIPLE">
                                Allow Multiple
                            </option>

                            <option value="SKIP_NEW_WORK">
                                Skip New Work
                            </option>

                            <option value="BLOCK_NEW_WORK">
                                Block New Work
                            </option>

                            <option value="MARK_OVERDUE_AND_CREATE">
                                Mark Overdue & Create
                            </option>

                        </select>

                    </div>

                    {/* Working Day Strategy */}

                    <div className="col-md-6 mb-3">

                        <label>

                            Working Day Strategy

                        </label>

                        <select
                            className="form-control"
                            value={schedule.working_day_strategy}
                            onChange={(e) =>
                                handleChange(
                                    "working_day_strategy",
                                    e.target.value
                                )
                            }
                        >

                            <option value="SKIP">
                                Skip
                            </option>

                            <option value="NEXT_WORKING_DAY">
                                Next Working Day
                            </option>

                            <option value="PREVIOUS_WORKING_DAY">
                                Previous Working Day
                            </option>

                        </select>

                    </div>

                    {/* Skip Holidays */}

                    <div className="col-md-3">

                        <div className="form-check mt-4">

                            <input
                                type="checkbox"
                                className="form-check-input"
                                checked={schedule.skip_holidays}
                                onChange={(e) =>
                                    handleChange(
                                        "skip_holidays",
                                        e.target.checked
                                    )
                                }
                            />

                            <label className="form-check-label">

                                Skip Holidays

                            </label>

                        </div>

                    </div>

                    {/* Skip Weekly Off */}

                    <div className="col-md-3">

                        <div className="form-check mt-4">

                            <input
                                type="checkbox"
                                className="form-check-input"
                                checked={schedule.skip_weekly_off}
                                onChange={(e) =>
                                    handleChange(
                                        "skip_weekly_off",
                                        e.target.checked
                                    )
                                }
                            />

                            <label className="form-check-label">

                                Skip Weekly Off

                            </label>

                        </div>

                    </div>

                    {/* Remarks */}

                    <div className="col-md-12 mt-3">

                        <label>

                            Remarks

                        </label>

                        <textarea
                            rows="3"
                            className="form-control"
                            value={schedule.remarks}
                            onChange={(e) =>
                                handleChange(
                                    "remarks",
                                    e.target.value
                                )
                            }
                        />

                    </div>

                </div>

            </div>

        </div>

    );

}